export const PowerTypesTable = () => {
  const powerTypes = [
    {
      type: "Real Power (P)",
      unit: "W, kW",
      description: "Actual work done. Powers motors, lights, heaters.",
      color: "power-real",
      usage: "Billing basis"
    },
    {
      type: "Apparent Power (S)",
      unit: "VA, kVA",
      description: "Total power drawn. Used for equipment sizing.",
      color: "power-apparent",
      usage: "Transformer sizing"
    },
    {
      type: "Reactive Power (Q)",
      unit: "VAR, kVAR",
      description: "Power oscillating in magnetic fields. No useful work.",
      color: "power-reactive",
      usage: "PF correction"
    }
  ];

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-2 px-2 text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Type
            </th>
            <th className="text-left py-2 px-2 text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Unit
            </th>
            <th className="text-left py-2 px-2 text-xs font-medium text-muted-foreground uppercase tracking-wider hidden sm:table-cell">
              Purpose
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {powerTypes.map((item) => (
            <tr key={item.type} className="hover:bg-secondary/30 transition-colors">
              <td className="py-3 px-2">
                <div className="flex items-center gap-2">
                  <div className={`w-2 h-2 rounded-full bg-${item.color}`} />
                  <span className="font-medium text-foreground">{item.type}</span>
                </div>
                <p className="text-xs text-muted-foreground mt-1 sm:hidden">
                  {item.description}
                </p>
              </td>
              <td className="py-3 px-2">
                <span className="font-mono text-primary text-xs">{item.unit}</span>
              </td>
              <td className="py-3 px-2 text-muted-foreground hidden sm:table-cell">
                <p className="text-xs">{item.description}</p>
                <span className="text-xs text-primary/70">{item.usage}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Power Factor Note */}
      <div className="mt-4 p-3 rounded-lg bg-secondary/30 border border-border">
        <p className="text-xs text-muted-foreground">
          <span className="font-medium text-foreground">Power Factor (PF)</span> = P/S 
          <span className="mx-1">•</span>
          Range: 0 to 1 
          <span className="mx-1">•</span>
          Unity PF (1.0) = pure resistive load
        </p>
      </div>
    </div>
  );
};
